var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u20B9 ",
    transform: "translate(0 24)",
    fill: "#ff4141",
    fontSize: 26,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9 "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedC);
export default __webpack_public_path__ + "static/media/red-c.e0983f8496c3eac51822503d2112fd0a.svg";
export { ForwardRef as ReactComponent };